module.exports = __webpack_public_path__ + "static/media/ipo4.dc7e166f.png";